import React, { Fragment } from 'react';
import { DRAWER_MODE } from 'components';
import { CustomizedSwitchWrapper } from 'components/CustomizedSwitchWrapper/CustomizedSwitchWrapper';
import { useHandleModuleNavigation } from 'hooks';
import { lazyCustom } from 'modules/taboola-common-frontend-modules/lazy-loading/lazyCustom';
import { resolveLazyComponent } from 'modules/taboola-common-frontend-modules/lazy-loading/resolveLazyComponent';
import { withSuspense } from 'modules/taboola-common-frontend-modules/lazy-loading/withSuspense';
import { LayerRoute } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/components/LayerRoute/LayerRoute';
import { ModuleRoute } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/components/ModuleRoute/ModuleRoute';
import { useMultiLayerDrawerEnabled } from '../../taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { EditDrawer } from '../components/EditDrawer/EditDrawer';
import { LANDING_PAGE_CREATOR_ROUTE_PATH, LANDING_PAGE_EDITOR_ROUTE_PATH, LANDING_PAGES_ROUTE } from '../config';
import { LandingPageEditor } from './LandingPageEditor';
import { LandingPagesReport } from './LandingPagesReport';

const LandingPageCreatorLazy = lazyCustom(() =>
    import('./LandingPageCreator').then(resolveLazyComponent('LandingPageCreator'))
);
const LandingPageCreator = withSuspense(LandingPageCreatorLazy);

const path = LANDING_PAGES_ROUTE;

export const LandingPages = ({ history }) => {
    const handleNavigation = useHandleModuleNavigation({ history, path });

    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    return (
        <Fragment>
            <CustomizedSwitchWrapper>
                <LayerRoute
                    exact
                    strict
                    path={LANDING_PAGE_CREATOR_ROUTE_PATH}
                    render={props => <LandingPageCreator {...props} onCancel={handleNavigation} />}
                />
                {isMultiLayerDrawerEnabled && (
                    <LayerRoute
                        exact
                        path={LANDING_PAGE_EDITOR_ROUTE_PATH}
                        drawerMode={DRAWER_MODE.MEDIUM_LARGE}
                        render={props => <LandingPageEditor {...props} onCancel={handleNavigation} />}
                    />
                )}
                <ModuleRoute path={path} render={props => <LandingPagesReport {...props} />} />
            </CustomizedSwitchWrapper>
            <EditDrawer onCancel={handleNavigation} />
        </Fragment>
    );
};
